module.exports = __webpack_public_path__ + "img/haiwaibuju-2.ad6b02fd.png";